import {
  ChangeCircle as ChangeCircleIcon,
  DeleteForever as DeleteForeverIcon,
  Upload as UploadIcon,
  Visibility as VisibilityIcon,
} from '@mui/icons-material';
import { MenuItem, Popover, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const IntegratedActionPopup = ({
  popoverElement,
  handleCloseMenu,
  handleUpdateAccount,
  handleDeletePost,
  handleReAuthenticate,
  handleViewLink,
  selectedPopOverPost,
}) => {
  const { t: translate } = useTranslation();
  return (
    <Popover
      open={Boolean(popoverElement)}
      anchorEl={popoverElement}
      onClose={handleCloseMenu}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          p: 1,
          width: 'auto',
          boxShadow: 3,
          borderRadius: 2,
          backdropFilter: 'blur(8px)',
          backgroundColor: 'action.disabledOpacity',
          boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.1)',
          '& .MuiMenuItem-root': {
            px: 2.5,
            py: 1.5,
            typography: 'body2',
            borderRadius: 2,
            transition: 'background-color 0.2s, transform 0.2s',
            display: 'flex',
            alignItems: 'center',
            '&:hover': {
              backgroundColor: 'action.disabledOpacity',
              transform: 'scale(1.02)',
            },
            '& .MuiSvgIcon-root': {
              fontSize: '1.5rem',
              marginRight: 2,
            },
            '& .MuiTypography-root': {
              fontWeight: 500,
            },
          },
        },
      }}
    >
      {selectedPopOverPost?.service_name !== 'gbusiness' && (
        <MenuItem onClick={handleViewLink}>
          <VisibilityIcon sx={{ mr: 1, color: 'primary.main' }} />
          <Typography sx={{ fontWeight: 500 }}>{translate('common.view_profile')}</Typography>
        </MenuItem>
      )}
      <MenuItem sx={{ color: 'common.black' }} onClick={handleUpdateAccount}>
        <UploadIcon sx={{ mr: 1, color: 'primary.main' }} />
        <Typography sx={{ fontWeight: 500 }}>{translate('common.update')}</Typography>
      </MenuItem>
      <MenuItem sx={{ color: 'common.black' }} onClick={handleReAuthenticate}>
        <ChangeCircleIcon sx={{ mr: 1, color: 'primary.main' }} />
        <Typography sx={{ fontWeight: 500 }}>{translate('common.reauthenticate')}</Typography>
      </MenuItem>
      <MenuItem sx={{ color: 'error.main' }} onClick={handleDeletePost}>
        <DeleteForeverIcon sx={{ mr: 1 }} />
        <Typography sx={{ fontWeight: 500 }}>{translate('common.delete')}</Typography>
      </MenuItem>
    </Popover>
  );
};

export default IntegratedActionPopup;
